import React from 'react';
import styled from 'styled-components';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';

import ExternalLink from '@common/ExternalLink';

import { Section, Container } from '@components/global';

// EPK URL commented out - will be added back later
// const epkUrl = 'https://1drv.ms/u/s!AkOQeC19V3QFd8uaTIRSjsvLuxg?e=AnnI1S';

const About = () => (
  <StaticQuery
    query={graphql`
      query {
        art_fast: file(
          sourceInstanceName: { eq: "art" }
          name: { eq: "fast" }
        ) {
          childImageSharp {
            fluid(maxWidth: 760) {
              ...GatsbyImageSharpFluid_withWebp_tracedSVG
            }
          }
        }

        art_learn: file(
          sourceInstanceName: { eq: "art" }
          name: { eq: "learn_yourself" }
        ) {
          childImageSharp {
            fluid(maxWidth: 760) {
              ...GatsbyImageSharpFluid_withWebp_tracedSVG
            }
          }
        }

        art_ideas: file(
          sourceInstanceName: { eq: "art" }
          name: { eq: "profile-pic-2025" }
        ) {
          childImageSharp {
            fluid(maxWidth: 760) {
              ...GatsbyImageSharpFluid_withWebp_tracedSVG
            }
          }
        }
      }
    `}
    render={data => (
      <Section id="bio">
        <Container>
          <Grid>
            <div>
              <h2>Bio</h2>
              <p>
                Yalung Tang es un cantautor venezolano radicado entre Buenos
                Aires y Montevideo que transforma experiencias personales y
                reflexiones sobre la vida moderna en canciones íntimas y
                visionarias. Su obra explora la relación entre lo humano y lo
                tecnológico, combinando letras honestas con un sonido que mezcla
                indie pop y electropop.
                <br />
                <br />
                Tras su debut con el álbum Tus Colores (2019) y el EP El Efecto
                Fantasmal (2022), Tang se prepara para el lanzamiento de su
                nuevo trabajo discográfico "El Bit y el Beat" (2026), un álbum
                conceptual que dialoga con la hiperconexión digital, la
                encriptación de la intimidad y la paradoja de la soledad en un
                mundo interconectado.
                <br />
                <br />
                El proyecto ya tuvo adelantos como "Todo encriptado" (2024) y
                "Ser" (2024), dos sencillos que muestran su interés por integrar
                la tecnología en la producción musical y en las narrativas
                audiovisuales, incorporando inteligencia artificial en el
                proceso creativo.
                <br />
                <br />
                Paralelamente a su carrera musical, Yalung Tang trabaja como
                desarrollador, lo que refuerza su identidad como artista
                tecnológico: un creador que cruza la frontera entre software y
                canción, entre datos y emociones. Su objetivo con El Bit y el
                Beat es ofrecer una experiencia que no solo se escuche, sino que
                invite a reflexionar sobre cómo vivimos, amamos y nos conectamos
                en la era digital.
              </p>
              <p>
                <br />
                {/* EPK section commented out - will be added back later
                <ExternalLink key={epkUrl} href={epkUrl}>
                  Descarga el EPK (Periodistas)
                </ExternalLink>
                */}
              </p>
            </div>
            <Art>
              <Img fluid={data.art_ideas.childImageSharp.fluid} />
            </Art>
          </Grid>
        </Container>
      </Section>
    )}
  />
);

const Grid = styled.div`
  display: grid;
  grid-template-columns: 3fr 2fr;
  grid-gap: 40px;
  text-align: right;
  align-items: center;
  justify-items: center;
  margin: 24px 0;

  ${props =>
    props.inverse &&
    `
    text-align: left;
    grid-template-columns: 2fr 3fr;
  `}

  h2 {
    margin-bottom: 16px;
  }

  @media (max-width: ${props => props.theme.screen.md}) {
    grid-template-columns: 1fr;
    text-align: left;
    margin-bottom: 96px;

    &:last-child {
      margin-bottom: 24px;
    }

    ${props =>
      props.inverse &&
      `
        ${Art} {
          order: 2;
        }
    `}
  }
`;

const Art = styled.figure`
  margin: 0;
  max-width: 380px;
  width: 100%;
`;

export default About;
